import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAlarmList } from '@/service/ys7';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  // 设备告警信息列表
  alarmList: {
    data: [],
    query: {}
  }
};

// 获取所有设备告警信息列表
export const fetchAlarmList = createAsyncThunk(
  'ys7Alarm/fetchAlarmList',
  async (body = {}, { rejectWithValue }) => {
    try {
      const response = await getAlarmList(body);
      return {
        data: response?.data,
        query: body
      };
    } catch (error) {
      return rejectWithValue(error?.response?.data || error?.message || '获取告警信息列表失败');
    }
  }
);

const alarmSlice = createSlice({
  name: 'ys7Alarm',
  initialState: defaultState,
  reducers: {
    resetAlarmState: () => defaultState
  },
  extraReducers: (builder) => {
    builder
      // fetchAlarmList
      .addCase(fetchAlarmList.pending, (state, action) => {
        state.fetching = true;
        state.error = null;
        state.alarmList.query = action.meta.arg || {};
      })
      .addCase(fetchAlarmList.fulfilled, (state, action) => {
        state.fetching = false;
        state.error = null;
        state.alarmList.data = action.payload?.data?.data || action.payload?.data || [];
        state.alarmList.query = action.payload?.query || {};
      })
      .addCase(fetchAlarmList.rejected, (state, action) => {
        state.fetching = false;
        state.error = action.payload;
        state.alarmList.data = [];
      });
  }
});

export const { resetAlarmState } = alarmSlice.actions;
export default alarmSlice.reducer;
